module.exports = __webpack_public_path__ + "img/Grabpay_SG.b9182e38.png";